import { EmailArtifactLocation } from '@amazon-connect/email';
import { EmailAttachment } from '../models/Email';
import { resolveEmailAttachments } from './resolveEmailAttachments';
import { getAttachmentStatus } from './uploadAttachment';

interface ResolveEmailAttachmentsWithStatus {
  attachments: EmailAttachment[];
  hasRejectedAttachments: boolean;
}

export const resolveEmailAttachmentsWithStatus = async (
  attachmentLocations: EmailArtifactLocation[] | undefined,
  contactId: string
): Promise<ResolveEmailAttachmentsWithStatus> => {
  if (!attachmentLocations || attachmentLocations.length === 0) {
    return { attachments: [], hasRejectedAttachments: false };
  }

  const statusResults = await Promise.allSettled(
    attachmentLocations.map(loc => getAttachmentStatus(contactId, loc.fileId))
  );

  const hasRejectedFiles = statusResults.some(r => r.status === 'fulfilled' && r.value.status === 'rejected');

  if (hasRejectedFiles) {
    return { attachments: [], hasRejectedAttachments: true };
  }

  const attachments = await resolveEmailAttachments(attachmentLocations, contactId);

  return { attachments, hasRejectedAttachments: false };
};
